import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";
import { Col, Skeleton, Typography } from "antd";
import { TypeList } from "features/comment/types/comment.type";
import React, { useEffect, useMemo, useRef, useState } from "react";

const { Text } = Typography;

type Props = {
  isLoading: boolean;
  content: string;
  style?: React.CSSProperties | undefined;
  parent_user: string | undefined;
  type_list: TypeList;
  is_shadow_text?: boolean;
  className?: string;
};

const styles = {
  text: {
    fontSize: "14px",
  },
};

const Description = ({
  isLoading,
  content = "",
  style = { width: "100%" },
  parent_user,
  type_list,
  is_shadow_text = false,
  className,
}: Props) => {
  const nodeReview = useRef<HTMLDivElement | null>(null);
  const nodeReviewViewMore = useRef<HTMLSpanElement | null>(null);
  const windowWidth = useRef(window.innerWidth);

  //
  const [isMore, setIsMore] = useState(false);

  //
  const handleToggleViewMore = (type: "open" | "close") => {
    if (nodeReview.current && nodeReviewViewMore) {
      const text = nodeReview.current;
      const btnMore = nodeReviewViewMore.current;
      if (text && btnMore && type === "close") {
        text.scroll({
          left: 0,
          top: 0,
          behavior: "smooth",
        });
        text.style.overflow = "hidden";
      } else {
        text.style.overflow = "auto";
        text.scroll({
          left: 0,
          top: 100,
          behavior: "smooth",
        });
      }
    }
    setIsMore((prev) => (type === "close" ? false : true));
  };
  const maxLengthText: number = useMemo(() => {
    if (window !== undefined) {
      if (windowWidth.current > 768) {
        return 300;
      } else if (windowWidth.current <= 450) {
        return 280;
      } else {
        return 300;
      }
    } else {
      return 280;
    }
  }, [window.innerWidth]);
  //
  return (
    <div className={className} style={{ ...style }}>
      {isLoading ? (
        <Skeleton loading={isLoading} active />
      ) : (
        <Col
          span={24}
          style={{
            overflow: "hidden",
            position: "relative",
            padding: 0,
          }}
        >
          <div
            ref={nodeReview}
            className="review-detail-shadow smooth-view-scrollbar"
          >
            <p
              style={{
                fontSize: "14px",
                color: "#3A393A",
                margin: 0,
              }}
            >
              {parent_user && (
                <span style={{ margin: 0, color: "#0186FF" }}>
                  @{parent_user}
                </span>
              )}{" "}
              {content}
            </p>
            {is_shadow_text &&
              !isMore &&
              content.split("").length >= maxLengthText && (
                <div className="fade-shadow-text"></div>
              )}
          </div>

          {is_shadow_text && content.split("").length >= maxLengthText && (
            <span
              id="more-shadow-text"
              ref={nodeReviewViewMore}
              style={{
                position: "relative",
                color: "#898889",
                fontSize: "12px",
                fontWeight: 400,
                lineHeight: "15px",
                textAlign: "right",
                float: "right",
                cursor: "pointer",
                margin: "10px 0 0 0",
              }}
            >
              {isMore ? (
                <div
                  onClick={() => handleToggleViewMore("close")}
                  style={{ display: "flex", alignItems: "center", gap: 8 }}
                >
                  Rút gọn
                  <IconChevronUp size={14}></IconChevronUp>
                </div>
              ) : (
                <div
                  onClick={() => handleToggleViewMore("open")}
                  style={{ display: "flex", alignItems: "center", gap: 8 }}
                >
                  Xem thêm
                  <IconChevronDown size={14}></IconChevronDown>
                </div>
              )}
            </span>
          )}
        </Col>
      )}
    </div>
  );
};

export default Description;
